import React, { useEffect, useState } from "react";
import { TextField } from "@mui/material";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { updateProfile } from "../../actions/customer";
import { showErrorSnackbar, showSuccessSnackbar } from "../../actions/snackbar";
import { authKey_local_storage_key, userInfo_local_storage_key } from "../../helpers/common";
import useStyles from "./styles";
import MetaTags from "../Common/MetaTags";
import AccountWrapper from "../Account/AccountWrapper";

export default function Profile() {
  const dispatch = useDispatch();
  const [loading, setLoading] = useState(false);
  const customer = useSelector((state) => state.customers.profile);
  const token = localStorage.getItem(authKey_local_storage_key);
  const classes = useStyles();
  const [errors, setErrors] = useState({});
  const { name, additional_mobile_number, mobile_number, pin_code, email } =
    useSelector((state) => state.customers.profile);
  const navigate = useNavigate();

  useEffect(() => {
    window.scrollTo({
      top: 0,
      behavior: 'smooth'
    })

    if (!token) {
      dispatch(
        showErrorSnackbar("You are not logged out ! Please login to continue")
      );
      navigate("/");
    }
  }, [token, navigate, dispatch]);

  const [profile, setProfile] = useState({
    name: name || "",
    email: email || "",
    pin_code: pin_code || "",
    mobile_number: mobile_number || "",
    additional_mobile_number: additional_mobile_number || "",
  });

  const onSubmit = (e) => {
    e.preventDefault();

    if (!profile.name) {
      setErrors({ ...errors, name: "Name is required" });
      return;
    }

    if (!profile.mobile_number) {
      setErrors({ ...errors, mobile_number: "Mobile number is required" });
      return;
    }

    setLoading(true);

    return dispatch(updateProfile({ ...profile, id: customer.id })).then(
      (res) => {
        setLoading(false);
        if (res.status === 200) {
          dispatch(showSuccessSnackbar("Profile Updated successfully !"));
          const customer = res.data;
          localStorage.setItem(userInfo_local_storage_key, JSON.stringify({ customer, token }));
        } else
          dispatch(showErrorSnackbar("Sorry! Profile cannot be updated !"));
      }
    );
  };

  const onValueChange = (event) => {
    setProfile({ ...profile, [event.target.name]: event.target.value });
  };

  return (
    <AccountWrapper title="My Profile">
      <section className={classes.profileSec} style={{ paddingTop: '0' }}>
        <MetaTags
          title="My Profile"
          description=""
          keywords=""
        ></MetaTags>

        <div className={classes.profileContainer}>
          {profile.name && profile.mobile_number ? (
            <div className={classes.profileCard}>
              <div className={classes.profileDetails}>
                <div className={classes.detailCard}>
                  <div className={classes.detailIcon}>
                    <i className="fa fa-user"></i>
                  </div>
                  <div className={classes.detailContent}>
                    <h6 className={classes.detailLabel}>Full Name</h6>
                    <p className={classes.detailValue}>{profile.name || '-'}</p>
                  </div>
                </div>

                <div className={classes.detailCard}>
                  <div className={classes.detailIcon}>
                    <i className="fa fa-phone"></i>
                  </div>
                  <div className={classes.detailContent}>
                    <h6 className={classes.detailLabel}>Mobile Number</h6>
                    <p className={classes.detailValue}>{profile.mobile_number || '-'}</p>
                  </div>
                </div>

                <div className={classes.detailCard}>
                  <div className={classes.detailIcon}>
                    <i className="fa fa-envelope"></i>
                  </div>
                  <div className={classes.detailContent}>
                    <h6 className={classes.detailLabel}>Email Address</h6>
                    <p className={classes.detailValue}>{profile.email || '-'}</p>
                  </div>
                </div>

                <div className={classes.detailCard}>
                  <div className={classes.detailIcon}>
                    <i className="fa fa-mobile"></i>
                  </div>
                  <div className={classes.detailContent}>
                    <h6 className={classes.detailLabel}>Alternate Mobile</h6>
                    <p className={classes.detailValue}>{profile.additional_mobile_number || '-'}</p>
                  </div>
                </div>
                
                <div className={classes.editButtonContainer}>
                  <button
                    onClick={() => navigate("/update-profile")}
                    className={classes.editButton}
                  >
                    <i className="fa fa-edit"></i>
                    Edit Profile
                  </button>
                </div>
              </div>
            </div>
          ) : (
            <div className={classes.setupCard}>
              <form className={classes.setupForm} onSubmit={onSubmit}>
                <div className={classes.formGroup}>
                  <TextField
                    className={classes.inputField}
                    fullWidth
                    value={profile.name}
                    variant="outlined"
                    name="name"
                    onChange={onValueChange}
                    label="Full Name *"
                    error={errors.name ? true : false}
                    helperText={errors.name}
                    InputProps={{
                      startAdornment: <i className="fa fa-user" style={{ marginRight: '10px', color: '#666' }}></i>
                    }}
                  />
                </div>

                <div className={classes.formGroup}>
                  <TextField
                    className={classes.inputField}
                    fullWidth
                    value={profile.mobile_number}
                    variant="outlined"
                    name="mobile_number"
                    label="Mobile Number *"
                    helperText={errors.mobile_number}
                    error={errors.mobile_number ? true : false}
                    InputProps={{
                      startAdornment: <i className="fa fa-phone" style={{ marginRight: '10px', color: '#666' }}></i>
                    }}
                  />
                </div>

                <div className={classes.formGroup}>
                  <TextField
                    className={classes.inputField}
                    fullWidth
                    variant="outlined"
                    type="email"
                    name="email"
                    label="Email Address"
                    value={profile.email}
                    onChange={onValueChange}
                    InputProps={{
                      startAdornment: <i className="fa fa-envelope" style={{ marginRight: '10px', color: '#666' }}></i>
                    }}
                  />
                </div>

                <div className={classes.formGroup}>
                  <TextField
                    className={classes.inputField}
                    fullWidth
                    value={profile.additional_mobile_number}
                    variant="outlined"
                    type="number"
                    name="additional_mobile_number"
                    label="Alternate Mobile Number"
                    onChange={onValueChange}
                    InputProps={{
                      startAdornment: <i className="fa fa-mobile" style={{ marginRight: '10px', color: '#666' }}></i>
                    }}
                  />
                </div>

                <div className={classes.formActions}>
                  <button className={classes.submitButton} type="submit">
                    {loading ? "Creating Profile..." : "Create Profile"}
                  </button>
                </div>
              </form>
            </div>
          )}
        </div>
      </section>
    </AccountWrapper>
  );
}
